var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("atm-sidebar", {
    attrs: {
      show: _vm.showSidebar,
      title: _vm.$t("Carrinho"),
      width: "700px",
      "no-close-on-backdrop": false,
    },
    on: { hidden: _vm.onHide },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "cart-container" },
              [
                _c(
                  "b-row",
                  { staticClass: "cart-itens-container position-relative" },
                  [
                    _vm.getItems.length > 0
                      ? [
                          _vm.hasCustomerIdentified && _vm.hasRewardBalance
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "ecash-section mt-1 mb-1",
                                  attrs: { md: "12" },
                                },
                                [
                                  _c("div", { staticClass: "ecash-card p-1" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center mb-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "ecash-logo-header mr-1",
                                              staticStyle: { display: "block" },
                                              attrs: {
                                                src: _vm.ecashLogo,
                                                alt: "ecash",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-0 h4 text-success font-weight-bold",
                                                staticStyle: {
                                                  display: "block",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " Temos desconto para você! "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center mb-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "ecash-logo",
                                              attrs: {
                                                src: _vm.ecashMoeda,
                                                alt: "ecash",
                                              },
                                            }),
                                            _c("div", { staticClass: "ml-1" }, [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "mb-0 font-weight-bold text-dark",
                                                },
                                                [
                                                  _vm._v(" Saldo ecash: "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "mb-0 h4 text-success font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatRewardBalance(
                                                            _vm.rewardBalance
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    !_vm.hasRewardsApplied
                                      ? _c(
                                          "div",
                                          [
                                            _c("e-button", {
                                              staticClass: "w-100 atm-btn",
                                              attrs: {
                                                variant: "success",
                                                text: "Usar saldo ecash",
                                                icon: "cash-coin",
                                                busy: _vm.ecashLoading,
                                              },
                                              on: { click: _vm.onApplyRewards },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-2 p-2 bg-light rounded",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "mb-0 text-success font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " ✓ Saldo ecash aplicado: " +
                                                        _vm._s(
                                                          _vm._f("currency")(
                                                            _vm.getRewardsAmountUsed
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("e-button", {
                                              staticClass: "w-100 atm-btn",
                                              attrs: {
                                                variant: "outline-danger",
                                                text: "Remover desconto ecash",
                                                icon: "x-circle",
                                              },
                                              on: {
                                                click: _vm.onRemoveRewards,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [_c("atm-reward-banner")],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c("atm-cart-item-list", {
                                attrs: {
                                  "cart-item-list": _vm.getItems,
                                  busy: _vm.addItemLoading,
                                },
                                on: { "add-suggestion": _vm.onAddSuggestion },
                              }),
                            ],
                            1
                          ),
                          _c("atm-cart-suggestions", {
                            attrs: {
                              "cart-items": _vm.getItems,
                              "sidebar-open": _vm.showSidebar,
                              busy: _vm.addItemLoading,
                              orientation: "horizontal",
                            },
                            on: { "add-suggestion": _vm.onAddSuggestion },
                          }),
                          _c(
                            "b-col",
                            {
                              staticClass: "position-sticky",
                              staticStyle: { bottom: "0" },
                              attrs: { md: "12" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-1 bg-white py-2 px-3 rounded",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between mb-1",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "h5 mb-0 text-muted" },
                                        [_vm._v(" Subtotal: ")]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "h5 mb-0 text-muted" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.getSubtotalSale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.hasRewardsApplied
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between mb-1",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "h5 mb-0 text-success",
                                            },
                                            [_vm._v(" Desconto ecash: ")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "h5 mb-0 text-success",
                                            },
                                            [
                                              _vm._v(
                                                " -" +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      _vm.getRewardsAmountUsed
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between border-top pt-2",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "h3 mb-0 font-weight-bold",
                                        },
                                        [_vm._v(" Total: ")]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "h3 mb-0 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  _vm.getTotalSale
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex justify-content-center align-items-center",
                            attrs: { md: "12" },
                          },
                          [_c("p", [_vm._v("Nenhum produto adicionado")])]
                        ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "sidebar-footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "cart-footer h-100" },
              [
                _c("e-button", {
                  staticClass: "atm-btn",
                  attrs: {
                    variant: "secondary",
                    text: _vm.$t("Continuar compra"),
                  },
                  on: {
                    click: function () {
                      return _vm.onHide()
                    },
                  },
                }),
                _c("e-button", {
                  staticClass: "atm-btn",
                  attrs: {
                    busy: _vm.paymentLoading || _vm.hasPendingActions,
                    variant: "primary",
                    text: _vm.$t("Pagamento"),
                  },
                  on: {
                    click: function () {
                      return _vm.onPayment()
                    },
                  },
                }),
              ],
              1
            ),
            _c("reward-terms-modal", {
              ref: "rewardTermsModal",
              on: { accept: _vm.onTermsAccepted, reject: _vm.onTermsRejected },
            }),
            _c("reward-code-verification-modal", {
              ref: "codeVerificationModal",
              on: {
                verified: _vm.onCodeVerified,
                cancelled: _vm.onCodeVerificationCancelled,
                close: function ($event) {
                  _vm.ecashLoading = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }